import { render, staticRenderFns } from "./land-main.vue?vue&type=template&id=180e3675"
import script from "./land-main.vue?vue&type=script&lang=js"
export * from "./land-main.vue?vue&type=script&lang=js"
import style0 from "./land-main.vue?vue&type=style&index=0&id=180e3675&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports